import { render, staticRenderFns } from "./AddUsers.vue?vue&type=template&id=9040dac6"
import script from "./AddUsers.vue?vue&type=script&lang=js"
export * from "./AddUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports